import { useNavigate } from 'react-router'
import { Check } from '@mui/icons-material'
import { Button, Link } from '@mui/material'

import turnOnScreenAnimation from '../../../animations/turn-on-sensor.json'
import BackButton from '../../../components/back-button'
import ScreenContainer from '../../../components/screen'
import SensorActivationAnimation from '../../../components/sensor-activation-animation'
import SensorActivationFooter from '../../../components/sensor-activation-footer'
import { useActivationContext } from '../../../providers/activation-provider'

const TurnOnSensorSlim = () => {
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 37,
      }}
      footerSpacing={148}
    >
      <SensorActivationAnimation animation={turnOnScreenAnimation} loop={true} />

      <SensorActivationFooter
        primaryButton={
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => navigate('/leak-pins', { state: activationLocationState })}
            startIcon={<Check />}
          >
            Sensor blinked or beeped
          </Button>
        }
        secondaryButton={
          <Link href="https://resources.meshify.com/defender-slim/#activation" rel="noopener noreferrer" target="_blank" underline="hover">
            I need help
          </Link>
        }
      />
    </ScreenContainer>
  )
}

export default TurnOnSensorSlim
